import Vue from 'vue';
import VueResource from 'vue-resource'
Vue.use(VueResource);

var contactForm = new Vue({
    el: "#contact-form",
    data: {
        message: '',
        gotResponse: false,
        success: false,
        errors: [],
    },
    methods: {
        submit: function (e) {
            let formData = new FormData(event.target);
            this.$refs.submitButton.disabled = true;

            this.$http.post(this.$el.getAttribute('action'), formData).then(response => {
                this._processResponse(response);
            }, response => {
                this._processResponse(response);
            });
        },
        _processResponse: function (response) {
                this.gotResponse = true;
                this.success = response.body.success;
                this.message = response.body.message;
                this.errors = response.body.errors ? response.body.errors : [];
                this.$refs.submitButton.disabled = false;
        }
    }
})
